// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b5c76175","453":"888f6670","455":"f4e34910","977":"2b8c489b"}[chunkId] + ".chunk.js";
};